export default "__VITE_ASSET__BM0DkY7O__"